module.exports = __webpack_public_path__ + "static/media/investBtn1.ae8902d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/investBtn1.png
// module id = 1785
// module chunks = 0 1